<template>
    <CFormGroup :error="error" :label="$t('ui.fields.firstName', lang)" :required="required">
        <CFormInput
            autocomplete="given-name"
            data-test-id="profileForm.firstName"
            :disabled="disabled"
            v-bind="$attrs"
            :model-value="modelValue"
            @update:model-value="$emit('update:modelValue', $event)"
            @change="$emit('change', $event)"
        />
        <template #side>
            <slot name="side" />
        </template>
        <template #footer>
            <slot name="footer" />
        </template>
    </CFormGroup>
</template>

<script setup lang="ts">
import CFormGroup from '@/components/ui/CFormGroup.vue'
import CFormInput from '@/components/ui/CFormInput.vue'

defineProps({
    modelValue: {
        type: String,
        default: undefined
    },
    disabled: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    },
    lang: {
        type: String,
        default: 'sk'
    },
    error: {
        type: String,
        default: undefined
    }
})

defineEmits(['update:modelValue', 'change'])
</script>